import './App.css';
import React, { useState, useEffect } from 'react';
import CustomButton from './Components/Buttons';
import Xarrow from 'react-xarrows';
import TopBar from './Components/TopBar'; 
import SurveyPage from './SurveyPage';
import DashSummary from './DashSummary';
import DashVideoSummary from './DashVideoSummary';
import { BrowserRouter as Router, Route, Routes, Link, useNavigate } from 'react-router-dom'; 
import { useTranslation, Trans } from 'react-i18next';
import DashVideoDetails from './DashVideoDetail';
import DashUserSummary from './DashUserSummary';
import DashUserDetail from './DashUserDetail';
import DashSurveySummary from './DashSurveySummary';
import DashRelatedSummary from './DashRelatedSummary';
import SurveyProfilePage from './SurveyProfilePage';
import PrototypePage from './PrototypePage'; 
import StartPage from './StartPage'; 
import Footer from './Components/Footer';

function App() {
  return (
    <Router>
      <div className="App">
          <TopBar />
          {/* All routes */}
          <Routes>
            <Route path="/start" element={<StartPage/>} />
            <Route path="/survey" element={<SurveyPage />} />
            <Route path="/prototype" element={<PrototypePage />} />
            <Route path="/surveyprofile" element={<SurveyProfilePage />} />
            <Route path="/dashsummary" element={<DashSummary />} /> 
            <Route path="/dashvideosummary" element={<DashVideoSummary />} />
            <Route path="/dashusersummary" element={<DashUserSummary />} />
            <Route path="/dashsurveysummary" element={<DashSurveySummary />} /> 
            <Route path="/dashrelatedsummary" element={<DashRelatedSummary />} /> 
            <Route path="/video/:id" element={<DashVideoDetails />} />
            <Route path="/userdetail/:userName" element={<DashUserDetail />} />
            
            <Route path="/" element={<Home />} />
          </Routes>
          <Footer />
      </div>
    </Router>
  );
}

function Home() {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const imageSize = Math.min(200, height * 0.2); 
  const centerImageSize = Math.min(250, height * 0.25); 

  const centerRef = React.useRef(null);
  const demoRef = React.useRef(null);
  const prototypeRef = React.useRef(null);
  const profileRef = React.useRef(null);
  const analyticsRef = React.useRef(null);


  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    console.log('Center Ref:', centerRef.current);
    console.log('Demo Ref:', demoRef.current);
    console.log('Prototype Ref:', prototypeRef.current);
    console.log('Profile Ref:', profileRef.current);
    console.log('Analytics Ref:', analyticsRef.current);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return (
    <>
     <div style={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
       /* gap: height * 0.0,
        padding: '0px',
        marginTop: '75px',
        position: 'relative'*/
        
      }}>
        {/* Top Row */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: height/3,
          flexWrap: 'wrap'
        }}>
          {/*<div ref={demoRef}  style={{cursor: 'pointer', textAlign: 'center', display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', gap: '20px'}} onClick={() => window.open('https://demointegra.dicapta.com/', '_blank')}>
            <img style={{  height: `${imageSize}px`, width: `${imageSize}px`  }} src={`${process.env.PUBLIC_URL}/Demo.png`} alt="Demo" />
            <span style={{ color: 'var(--primary-color)', fontSize: '1.5rem' }}>{t('demo')}</span>
          </div>*/}
          <div ref={prototypeRef}  style={{cursor: 'pointer', textAlign: 'center', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px', marginBottom: '50px'}} onClick={() => navigate('/prototype')}>
            <img style={{  height: `${imageSize}px`, width: `${imageSize}px`  }} src={`${process.env.PUBLIC_URL}/Prototype.png`} alt="Prototype" />
            <span style={{ color: 'var(--primary-color)', fontSize: '1.5rem' }}>{t('prototype')}</span>
          </div>
        </div>
        
        {/* Center Row */}
        <div ref={centerRef}  className="icon-container">
          <img 
            src={`${process.env.PUBLIC_URL}/AppIcon.png`} 
            alt="App Icon" 
            className="app-icon"
            style={{ height: `${centerImageSize}px`, width: `${centerImageSize}px`, margin: '0px' }} 
          />
        </div>

        {/* Bottom Row */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: height/3,
          flexWrap: 'wrap'
        }}>
          <div ref={profileRef}  style={{cursor: 'pointer', textAlign: 'center', display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', gap: '20px'}} onClick={() => navigate('/start')}>
            <img style={{ height: `${imageSize}px`, width: `${imageSize}px`  }} src={`${process.env.PUBLIC_URL}/CreateProfile.png`} alt="Create Profile" />
            <span style={{ color: 'var(--primary-color)', fontSize: '1.5rem' }}>{t('createProfile')}</span>
          </div>
          <div ref={analyticsRef}  style={{cursor: 'pointer', textAlign: 'center', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px'}} onClick={() => navigate('/dashsummary')}>
            <img style={{  height: `${imageSize}px`, width: `${imageSize}px`  }} src={`${process.env.PUBLIC_URL}/Analytics.png`} alt="Analytics" />
            <span style={{ color: 'var(--primary-color)', fontSize: '1.5rem' }}>{t('topBarDash')}</span>
          </div>
        </div>
      </div>
      {/* Arrows */}
       {/* <Xarrow
          start={centerRef}
          end={demoRef}
          color="var(--primary-color)"
          strokeWidth={5}  
          path="straight"
          startAnchor={["top", "left"]}
          endAnchor="bottom"
          dashness={{ strokeLen: 10, nonStrokeLen: 5, animation: 0 }}
        />*/}
        <Xarrow
          start={centerRef}
          end={prototypeRef}
          color="var(--primary-color)"
          strokeWidth={5} 
          path="straight"
          startAnchor={["top", "right"]}
          endAnchor="bottom"
          dashness={{ strokeLen: 10, nonStrokeLen: 5, animation: 0 }}
        />
        <Xarrow
          start={centerRef}
          end={profileRef}
          color="var(--primary-color)"
          strokeWidth={5}
          path="straight"
          startAnchor={["bottom", "left"]}  
          endAnchor="top"  
          dashness={{ strokeLen: 10, nonStrokeLen: 5, animation: 0 }}
        />
        <Xarrow
          start={centerRef}
          end={analyticsRef}
          color="var(--primary-color)"
          strokeWidth={5}
          path="straight"
          startAnchor={["bottom", "right"]} 
          endAnchor="top" 
          dashness={{ strokeLen: 10, nonStrokeLen: 5, animation: 0 }}
        />

      
    </>
  );
}

export default App;